// extracted by mini-css-extract-plugin
module.exports = {"main":"SheetCutting_main__3ZtBV","imgContainer":"SheetCutting_imgContainer__1Cq-L","inputs":"SheetCutting_inputs__1wm-g index_caption__1AJ2W"};